export default __webpack_public_path__ + "static/media/personalDetailshelp.cb2bf3b7.png";